export default __webpack_public_path__ + "static/media/logo.a5483cb9.svg";